/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { StreamerBoxStreamerBoxDevicesListQueryResponse } from "../models/StreamerBoxStreamerBoxDevicesList";

export function getStreamerBoxStreamerBoxDevicesListUrl() {
  const res = { method: 'GET', url: `/streamer-box/devices` as const }
  return res
}

/**
 * @description Returns Balena devices for the authenticated client. Superadmin users receive all devices; other client admins receive devices tagged with their client slug (`customer` tag).
 * @summary List devices
 * {@link /streamer-box/devices}
 */
export async function streamerBoxStreamerBoxDevicesList(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<StreamerBoxStreamerBoxDevicesListQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getStreamerBoxStreamerBoxDevicesListUrl().url.toString(), ... requestConfig })
  return res.data
}